import { render, staticRenderFns } from "./QRCodeHTMLComponent.vue?vue&type=template&id=39aae6ee&"
import script from "./QRCodeHTMLComponent.vue?vue&type=script&lang=js&"
export * from "./QRCodeHTMLComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39aae6ee')) {
      api.createRecord('39aae6ee', component.options)
    } else {
      api.reload('39aae6ee', component.options)
    }
    module.hot.accept("./QRCodeHTMLComponent.vue?vue&type=template&id=39aae6ee&", function () {
      api.rerender('39aae6ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/components/QRCodeHTMLComponent.vue"
export default component.exports